import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, SinglePaymentDialogueHandler } from './types';
import SinglePaymentDialogueContext from './SinglePaymentContext';

const { ConfirmationDialogue } = vp;

type SinglePaymentDialogueProps = {
  handleDialogue: DialogueHandler<SinglePaymentDialogueHandler>;
};

type FC = FunctionComponent<SinglePaymentDialogueProps>;

const SinglePaymentDialogue: FC = ({ handleDialogue }: SinglePaymentDialogueProps) => {
  const { showSinglePaymentErrorAlert, singlePaymentError, showSinglePaymentConfirmAlert } =
    useContext(SinglePaymentDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* Single Payment Error */}
        <ConfirmationDialogue
          isVisible={showSinglePaymentErrorAlert}
          title="Error! The payment was not completed."
          status="error"
          subTitle={`${singlePaymentError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />

        {/* Single Payment Confirm */}
        <ConfirmationDialogue
          isVisible={showSinglePaymentConfirmAlert}
          title="Submit Payment?"
          status="alert"
          subTitle="Once payment is submitted, your transaction will begin processing. Please ensure all details are accurate before submission."
          confirm={{
            label: 'Submit Payment',
            action: () => handleDialogue({ type: 'confirm', state: 'confirm' }),
          }}
          cancel={{
            label: 'Go Back',
            action: () => handleDialogue({ type: 'confirm', state: 'cancel' }),
          }}
        />
      </div>
    ),
    [showSinglePaymentErrorAlert, singlePaymentError, showSinglePaymentConfirmAlert],
  );
};

export default SinglePaymentDialogue;
